export const COLORS = {
  primary: '#FF5E1E',
  primaryLight: 'rgba(255, 94, 30, 0.04)',
  textSecondary: 'rgba(0, 0, 0, 0.6)',
  textPrimary: '#000',
  iconDefault: '#00000099',
  hoverBg: '#00000099',
  hoverText: '#ffff',
  white: 'white',
} as const

export const actionIconBaseSx = {
  color: COLORS.iconDefault,
  transition: 'opacity 0.3s ease-in-out',
  gap: '0',
  gridGap: '0',
  textAlign: 'left',
  ':hover': {
    color: COLORS.hoverText,
    backgroundColor: COLORS.hoverBg,
    borderRadius: '4px',
  },
}

export const getActionIconSx = (visible: boolean, extraSx: Record<string, any> = {}) => ({
  ...actionIconBaseSx,
  opacity: visible ? 1 : 0,
  ...extraSx,
})

/**
 * CSS-based hover styles for the DataGrid.
 * Action icons are hidden by default and shown on row hover via CSS,
 * eliminating the need for inHoverRow state and per-mouseover re-renders.
 */
export const dataGridCssHoverSx = {
  '& .MuiDataGrid-row .MuiDataGrid-actionsCell .MuiButtonBase-root': {
    opacity: 0,
    transition: 'opacity 0.3s ease-in-out',
  },
  '& .MuiDataGrid-row:hover .MuiDataGrid-actionsCell .MuiButtonBase-root': {
    opacity: 1,
  },
}

export const toolbarButtonSx = {
  my: 1,
  height: '36px',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '16px',
  gap: '8px',
  color: COLORS.textSecondary,
  ':hover': {
    color: COLORS.primary,
  },
}

export const toolbarIconSx = {
  width: '22px',
  height: '22px',
}

export const toggleButtonHoverSx = {
  ':hover': {
    backgroundColor: COLORS.primaryLight,
    border: `1px solid ${COLORS.primary}`,
    borderLeft: `1px solid ${COLORS.primary} !important`,
    color: COLORS.primary,
    svg: {
      color: COLORS.primary,
    },
  },
}

export const toggleGroupSelectedSx = {
  '& .Mui-selected': {
    backgroundColor: `${COLORS.primaryLight} !important`,
    color: `${COLORS.primary} !important`,
  },
  marginRight: '20px',
}
